export type PressOutlet = {
  id: string;
  /** Masthead name. Used as the logo's alt text, and rendered as text if the logo is missing. */
  outlet: string;
  url: string;
  /**
   * Path to the masthead in `public/press/`. Must have a transparent background.
   * Raster marks are whitened by the `.press-logo` filter so six different logos
   * read as one system; pre-coloured vectors opt out via `logoClass`.
   * Omit (or point at a missing file) and the outlet name renders as text instead.
   */
  logo?: string;
  /** Intrinsic logo dimensions reserve the masthead slot before the file loads. */
  width?: number;
  height?: number;
  /** Per-outlet sizing, since mastheads range from 10:1 to square. */
  logoClass?: string;
};

export type PressStory = {
  id: string;
  headline: string;
  date?: string;
  outlets: PressOutlet[];
};

export const PRESS_STORIES: PressStory[] = [
  {
    id: 'vision-models',
    headline:
      'Induce AI is training its own vision models to reason about film at a level general-purpose LLMs cannot',
    date: '2026-09-02',
    outlets: [
      {
        id: 'hindustan-times',
        outlet: 'Hindustan Times',
        url: 'https://www.hindustantimes.com/brand-stories/induce-ai-says-it-is-training-its-own-vision-models-to-reason-about-film-in-ways-general-purpose-llms-cannot-101788334649825.html',
        logo: '/press/hindustan-times.svg',
        width: 460,
        height: 59,
        logoClass: 'press-logo--asis h-[27px] max-w-[210px]',
      },
      {
        id: 'the-print',
        outlet: 'ThePrint',
        url: 'https://theprint.in/ani-press-releases/induce-ai-is-training-its-own-vision-models-to-reason-about-film-at-a-level-general-purpose-llms-cannot/3031428/',
        logo: '/press/theprint.png',
        width: 800,
        height: 149,
        logoClass: 'h-[23px] max-w-[135px]',
      },
      {
        id: 'the-tribune',
        outlet: 'The Tribune',
        url: 'https://www.tribuneindia.com/news/business/induce-ai-is-training-its-own-vision-models-to-reason-about-film-at-a-level-general-purpose-llms-cannot/',
        logo: '/press/the-tribune.webp',
        width: 350,
        height: 106,
        logoClass: 'h-[34px] max-w-[130px]',
      },
      {
        id: 'ani-news',
        outlet: 'ANI News',
        url: 'https://www.aninews.in/news/business/induce-ai-is-training-its-own-vision-models-to-reason-about-film-at-a-level-general-purpose-llms-cannot20260902100500/',
        logo: '/press/ani-news.png',
        width: 307,
        height: 86,
        logoClass: 'h-[30px] max-w-[115px]',
      },
    ],
  },
  {
    id: 'rhapsody-beta',
    headline:
      'Induce AI opens public beta of Rhapsody 1.0, an engine that reasons and checks AI film for story logic before it ships',
    date: '2026-09-02',
    outlets: [
      {
        id: 'the-wire',
        outlet: 'The Wire',
        url: 'https://thewire.in/ptiprnews/induce-ai-opens-public-beta-of-rhapsody-1-0-an-engine-that-reasons-and-checks-ai-film-for-story-logic-before-it-ships',
        logo: '/press/the-wire.svg',
        width: 116,
        height: 40,
        logoClass: 'press-logo--asis h-[28px] max-w-[105px]',
      },
      {
        id: 'pti-news',
        outlet: 'PTI News',
        url: 'https://www.ptinews.com/press-release/induce-ai-opens-public-beta-of-rhapsody-1-0-an-engine-that-reasons-and-checks-ai-film-for-story-logic-before-it-ships/4026827',
        logo: '/press/pti-news.png',
        width: 780,
        height: 97,
        // The full "Press Trust of India" lockup is 8:1 — the widest mark in the strip.
        // This story carries only two outlets, so it has the room.
        logoClass: 'h-[32px] max-w-[260px]',
      },
    ],
  },
];
